import { logQoSError } from '../Reliability/QoSErrorHelpers';
import { GenericTelemetryTracker } from './GenericTelemetryTracker';
/**
 * The CreateNewTracker helps FFX team track Reliability and Performance on the CreateNew path.
 * The basic idea is that the host app instantiates the tracker before the createNew scenario starts and calls setSuccess or setFailure to log the result appropriately.
 * The CreateNewTracker accepts a param trackLater, that gives the host app an opportunity to create the tracker early in the lifecycle but only start perf measurement when they want to, by calling the startActivity method on the tracker.
 */
/**
 * It's possible that a user exits a createNew scenario before the file creation/container attach finishes.
 * In such cases FFX has observed that fake fetch failures get logged on the CreateNew path that drop reliability numbers for CreateNew.
 * To solve this problem, we expose a dispose method on the CreateNew tracker, so host apps can call dispose on the tracker if they see user navigating away from the scenario.
 * For sourceless iframe path, host apps also have the option to pass an onDispose callback to the sourcelessIframeLoadOptions that can dispose the createNewTracker on their behalf when the Iframe disposes.
 * This is useful for both avoiding accidental logging and memory cleanups.
 */
/**
 * @deprecated
 * (Host apps should not remove this tracker from their code yet. We will reach out to you once we are ready to decommision this event in our
 * reliability dashboards ADO: 6249511. Any new usage should be avoided)
 */
export class CreateNewTracker extends GenericTelemetryTracker {
    constructor(logger, createNewTrackerOptions) {
        super("RealizeNewFile" /* Activity.RealizeNewFile */, logger, createNewTrackerOptions);
        this.createNewTrackerOptions = createNewTrackerOptions;
    }
    /**
     * Call this method to end the activity and send the failure status
     * @param onAttach Set as true if the failure happens while attaching the container
     * @param error Error object thrown
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any
  -- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */
    setFailure(onAttach, error) {
        // Log a QoS Error if container attach or getAbsoluteUrl fail
        this.OWHNamespacedLogger &&
            logQoSError(this.OWHNamespacedLogger, "RealizeNewFile" /* Activity.RealizeNewFile */, "Create" /* OWHAshaPillar.Create */, "FileCreateFailed" /* OWHAshaVeto.FileCreateFailed */, error.errorType ||
                (onAttach
                    ? "ContainerAttachFailed" /* OWHAshaErrorType.ContainerAttachFailed */
                    : "GetAbsoluteUrlFailed" /* OWHAshaErrorType.GetAbsoluteUrlFailed */) /*Asha ErrorType*/, undefined /*additionalProps */, error);
        super.setFailure(error);
    }
}
//# sourceMappingURL=CreateNewTracker.js.map